import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        activeName: ''
    },
    mutations: {
        activate(state, payload) {
            // if (state.activeName == '') {
            state.activeName = payload.activeName;
            // console.log(state.activeName);
            // }
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js